"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montefalcone-appennino": {
    "ea427d04": [{
      "hkey": "f2af340a",
      "slug": "montefalcone-appennino",
      "name": "Montefalcone Appennino",
      "primary": true,
      "skipSearch": false
    }],
    "bofaro": [{
      "hkey": "f2af340a",
      "slug": "montefalcone-appennino",
      "name": "Montefalcone Appennino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ba844110": [{
      "hkey": "f2af340a",
      "slug": "montefalcone-appennino",
      "name": "Montefalcone Appennino",
      "primary": true,
      "skipSearch": false
    }],
    "cese": [{
      "hkey": "f2af340a",
      "slug": "montefalcone-appennino",
      "name": "Montefalcone Appennino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "08ff2639": [{
      "hkey": "f2af340a",
      "slug": "montefalcone-appennino",
      "name": "Montefalcone Appennino",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-luogo-di-sasso": [{
      "hkey": "f2af340a",
      "slug": "montefalcone-appennino",
      "name": "Montefalcone Appennino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b49f091d": [{
      "hkey": "f2af340a",
      "slug": "montefalcone-appennino",
      "name": "Montefalcone Appennino",
      "primary": true,
      "skipSearch": false
    }],
    "faveto": [{
      "hkey": "f2af340a",
      "slug": "montefalcone-appennino",
      "name": "Montefalcone Appennino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "25a1b6ea": [{
      "hkey": "f2af340a",
      "slug": "montefalcone-appennino",
      "name": "Montefalcone Appennino",
      "primary": true,
      "skipSearch": false
    }],
    "marulla": [{
      "hkey": "f2af340a",
      "slug": "montefalcone-appennino",
      "name": "Montefalcone Appennino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0ccd1790": [{
      "hkey": "f2af340a",
      "slug": "montefalcone-appennino",
      "name": "Montefalcone Appennino",
      "primary": true,
      "skipSearch": false
    }],
    "san-biagio": [{
      "hkey": "f2af340a",
      "slug": "montefalcone-appennino",
      "name": "Montefalcone Appennino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "65689c2d": [{
      "hkey": "f2af340a",
      "slug": "montefalcone-appennino",
      "name": "Montefalcone Appennino",
      "primary": true,
      "skipSearch": false
    }],
    "san-lorenzo": [{
      "hkey": "f2af340a",
      "slug": "montefalcone-appennino",
      "name": "Montefalcone Appennino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;